import { SET_HOMEPAGE_CATEGORY } from "../actionTypes";
import { initialState } from "../initialState";

const homepageCategorySelectionReducer = (
    state = initialState.homepageCategorySelection,
    action
) => {
    switch (action.type) {
        case SET_HOMEPAGE_CATEGORY:
            return action.payload;
        default:
            return state;
    }
};

export default homepageCategorySelectionReducer;
